(function() {
    'use strict';
    angular
        .module('valueconnectApp')
        .factory('LenderTorRule', LenderTorRule);

    LenderTorRule.$inject = ['$resource'];

    function LenderTorRule ($resource) {
        var resourceUrl = 'api/lender-tor-rules/:id';

        return $resource(resourceUrl, {}, {
            'get': { method: 'GET' },
            'getByLender': {
                method: 'GET',
                url: 'api/lender-tor-rules-fromlender/:lenderId',
                isArray: true
            },
            'update': { method: 'PUT' }
        });
    }
})();
